import React from 'react';
import ConfigStore from '../../../../../stores/ConfigStore';
import ChangePasswordModal from './ChangePasswordModal';

export default function ChangePasswordModalContainer(props) {
  const { appNameShort } = ConfigStore.useStore();

  return <ChangePasswordModal appNameShort={appNameShort} {...props} />;
}
